import { Box, Typography, Container } from "@mui/material";
import { Helmet } from "react-helmet-async";
import NotFoundImage from "../../assets/images/404.svg";
import { APP_TITLE } from "../../constant";

function Status404() {
  return (
    <>
      <Helmet>
        <title>404 – Page Not Found | {APP_TITLE}</title>
        <meta
          name="description"
          content="The page you are looking for does not exist or has been moved."
        />
      </Helmet>

      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Container maxWidth="md">
          <Box textAlign="center">
            <img alt="404" height={180} src={NotFoundImage} />
            <Typography variant="h2" sx={{ mt: 2 }}>
              Page Not Found
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
}

export default Status404;
